import React, { Component } from "react";
import ReactDOM from "react-dom";
import cn from "classnames";
import Layout from "../Layout";
import "./VtapeLayout.less";
import AbsoluteLayout from "../AbsoluteLayout";
import FillLayout from "../fill/FillLayout";

const CLASS_NAME = "fct-vertical-tape-layout";

class VerticalTapeLayout extends Component {
  static defaultProps = {
    scrollable: false
  };

  render() {
    const {
      children,
      className,
      lgap = 0,
      rgap = 0,
      tgap = 0,
      bgap = 0,
      hgap = 0,
      vgap = 0,
      ...props
    } = this.props;
    let top = 0,
      bottom = 0;
    const topMap = {},
      bottomMap = {};
    const count = React.Children.count(children);
    React.Children.forEach(children, (child, i) => {
      if (child) {
        top >= 0 && (top += tgap + vgap);
        topMap[i] = top;
        if (top >= 0 && child.props.height >= 0) {
          top += child.props.height;
        } else {
          top = -1;
        }
      }
      if (children[count - i - 1]) {
        bottom >= 0 && (bottom += bgap + vgap);
        bottomMap[count - i - 1] = bottom;
        if (bottom >= 0 && children[count - i - 1].props.height >= 0) {
          bottom += children[count - i - 1].props.height;
        } else {
          bottom = -1;
        }
      }
    });
    return (
      <AbsoluteLayout className={cn(CLASS_NAME, className)} {...props}>
        {React.Children.map(children, (child, i) => {
          return (
            child &&
            React.cloneElement(child, {
              left: lgap + hgap,
              right: rgap + hgap,
              ...(topMap[i] >= 0
                ? {
                    top: topMap[i]
                  }
                : {}),
              ...(bottomMap[i] >= 0
                ? {
                    bottom: bottomMap[i]
                  }
                : {}),
              ...child.props
            })
          );
        })}
      </AbsoluteLayout>
    );
  }
}

VerticalTapeLayout.Item = FillLayout;
export default VerticalTapeLayout;



// WEBPACK FOOTER //
// ./layout/tape/VtapeLayout.js